import { faGear } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ExtensionType } from "backend/src/common/types/ExtensionCard";
import { useState } from "react";
import { Button, Form, Modal, Navbar } from "react-bulma-components";
import { debug_addExtension } from "socket/events/debug_addExtension";
import { debug_addFood } from "socket/events/debug_addFood";
import { debug_addRandomAnimal } from "socket/events/debug_addRandomAnimal";
import { store } from "store/store";
import { useI18n } from "i18n/I18nProvider";
import { getExtensionTexts } from "backend/src/common/i18n";

export const Devtools = () => {
  const [show, setShow] = useState(false);
  const { locale, t } = useI18n();
  return (
    <>
      <Modal show={show} onClose={() => setShow(false)} closeOnEsc closeOnBlur>
        <Modal.Card>
          <Modal.Card.Header onClose={() => setShow(false)}>
            <Modal.Card.Title>{t("devtools.title")}</Modal.Card.Title>
          </Modal.Card.Header>
          <Modal.Card.Body>
            {Object.values(ExtensionType).map((type) => (
              <Form.Field key={type}>
                <Button.Group hasAddons>
                  <Button
                    color="primary"
                    onClick={() => {
                      debug_addExtension(type);
                    }}
                  >
                    {getExtensionTexts(locale, type).name}
                  </Button>
                  {[3, 5, 10].map((amount) => (
                    <Button
                      key={amount}
                      onClick={() => {
                        debug_addExtension(new Array(amount).fill(type));
                      }}
                    >
                      x{amount}
                    </Button>
                  ))}
                </Button.Group>
              </Form.Field>
            ))}
            <div>
              <hr />
            </div>
            <div>
              <Button
                color="warning"
                onClick={() => {
                  debug_addRandomAnimal();
                }}
              >
                {t("devtools.addRandomAnimal")}
              </Button>
            </div>
            <div>
              <hr />
            </div>
            {[1, 3, 5].map((count) => (
              <Button.Group hasAddons key={count}>
                <Button
                  color="primary"
                  onClick={() => {
                    debug_addFood(count);
                  }}
                >
                  {t("devtools.addFood", {
                    count,
                  })}
                </Button>
                <Button
                  color="danger"
                  onClick={() => {
                    debug_addFood(-count);
                  }}
                >
                  {t("devtools.removeFood", {
                    count,
                  })}
                </Button>
              </Button.Group>
            ))}
            <div>
              <hr />
            </div>
            <div>
              <Button
                color="danger"
                onClick={() => {
                  debug_addFood(-store.gameState.foodOnTheTable);
                }}
              >
                {t("devtools.deleteAllFood")}
              </Button>
            </div>
          </Modal.Card.Body>
        </Modal.Card>
      </Modal>
      <Navbar.Item
        onClick={() => {
          setShow(!show);
        }}
      >
        <FontAwesomeIcon icon={faGear} />
      </Navbar.Item>
    </>
  );
};
